import { useNavigate, Navigate, useParams } from 'react-router-dom';
import { React, useState, useEffect, useContext } from 'react';
import * as menu from "../../assets/menus/menu.js"
import * as api from "../../api/apiConnector.js";
import UserContext from '../../components/User_Context.js';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import Undo_Redo from "../../components/ui/undo_redo.js";
import { useTranslation } from 'react-i18next';


const Vocs_Editor = (params) => {
    const { voc_id } = useParams();
    const [data, setData] = useState(null);
    const { currentUser } = useContext(UserContext);
    let undo_redo = null;
    const { t } = useTranslation();





    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t('home', { ns: 'labels' })
        },
        {
            link: "/admin",
            name: t('admin', { ns: 'labels' })
        }
        ];

        switch (voc_id) {
            case "functional_chart_roles":
                path.push(
                    {
                        link: "/admin/vocs/functional_chart_roles",
                        name: t('functionalRoles', { ns: 'labels' })
                    }
                );
                break;
            case "organizational_chart_roles":
                path.push(
                    {
                        link: "/admin/vocs/organizational_chart_roles",
                        name: t('organizationalRoles', { ns: 'labels' })
                    }
                );
                break;
            case "business_unit_types":
                path.push(
                    {
                        link: "/admin/vocs/business_unit_types",
                        name: t('businessUnitType', { ns: 'labels' })
                    }
                );
                break;
            case "requisites_main_contexts":
                path.push(
                    {
                        link: "/admin/vocs/requisites_main_contexts",
                        name: t('requisitesMainContexts', { ns: 'labels' })
                    }
                );
                break;
            case "hand_hygiene_oms_departments_category":
                path.push(
                    {
                        link: "/admin/vocs/hand_hygiene_oms_departments_category",
                        name: t('handHygieneDepartmentsCategory', { ns: 'labels' })
                    }
                );
                break;
            case "hand_hygiene_oms_operators":
                path.push(
                    {
                        link: "/admin/vocs/hand_hygiene_oms_operators",
                        name: t('handHygieneOperators', { ns: 'labels' })
                    }
                );
                break;
            case "hospital_regimen_types":
                path.push(
                    {
                        link: "/admin/vocs/hospital_regimen_types",
                        name: t('hospitalRegimenTypes', { ns: 'labels' })
                    }
                );
                break;
            case "risk_area":
                path.push(
                    {
                        link: "/admin/vocs/risk_area",
                        name: t('riskArea', { ns: 'labels' })
                    }
                );
                break;
            case "form_groups":
                path.push(
                    {
                        link: "/admin/vocs/form_groups",
                        name: t('formGroups', { ns: 'labels' })
                    }
                );
                break;
            case "dms_classification_types":
                path.push(
                    {
                        link: "/admin/vocs/dms_classification_types",
                        name: t('dmsClassificationType', { ns: 'labels' })
                    }
                );
                break;
            case "dms_category_types":
                path.push(
                    {
                        link: "/admin/vocs/dms_category_types",
                        name: t('dmsCategoryType', { ns: 'labels' })
                    }
                );
                break;
            case "dms_files_validation_flow":
                path.push(
                    {
                        link: "/admin/vocs/dms_files_validation_flow",
                        name: t('dmsValidationFlowTyps', { ns: 'labels' })
                    }
                );
                break;
            case "dmsKeyWords":
                path.push(
                    {
                        link: "/admin/vocs/dmsKeyWords",
                        name: t('dmsCategoryType', { ns: 'labels' })
                    }
                );
                break;

            default:
                break
        }


        breadcrumb.set(path);

    }

    const _save = async (params) => {

        withReactContent(Swal).fire({
            title: t('saving', { ns: 'labels' }),
            icon: "info",
            text: t('savingNewData', { ns: 'labels' }),
            allowOutsideClick: false
        });

        var result = await api.sendMessage("admin/vocs/set", {
            user: currentUser(),
            body: {
                items: data.data,
                voc_id: voc_id
            }
        });

        if (!result.success) {
            if (result.message === "UNAUTHORIZED") {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: t(result.message.toLowerCase(), { ns: 'labels' }),
                    showConfirmButton: true,
                    allowOutsideClick: false
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.href = `/`;
                    }
                });
            }
            else if (result.message) {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true,

                })
            }
        }
        else {

            withReactContent(Swal).fire({
                title: t('info', { ns: 'labels' }),
                icon: "success",
                text: t('vocSavedCorrectly', { ns: 'labels' }),
                showConfirmButton: true,

            })

        }

        return null;
    }

    const _deleteRow = async (params) => {
        const { row } = params;

        data.data.splice(data.data.findIndex(x => x === row), 1);
        setData({
            voc_schema: data.voc_schema,
            data: data.data
        });
    }

    const _getData = async (params) => {
        var result = await api.sendMessage("admin/vocs/get", {
            user: currentUser(),
            body: {
                voc_id: voc_id
            }
        });

        return result;
    }



    useEffect(() => {
        (async () => {
            setBreadCrumb();
            menu.write({ user: currentUser() });
            var voc_data = await _getData();

            if (voc_data.success) {
                setData({
                    data: voc_data.items,
                    voc_schema: _getSchema()
                });
                undo_redo.push(voc_data.items);
            }
            else {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: t(voc_data.message.toLowerCase(), { ns: 'labels' }),
                    showConfirmButton: true,
                    allowOutsideClick: false
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        window.location.href = "/";
                    }
                });
            }
        })();
    }, []);


    useEffect(() => {
        setBreadCrumb()
    }, [data]);

    //get voc schema
    const _getSchema = () => {
        switch (voc_id) {


            case "form_groups":
                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    },
                    {
                        fieldName: "Active",
                        fieldType: "bool",
                        key: true,
                        hidden: true,
                        name: t('active', { ns: 'labels' })
                    },
                ];
                break;
            case "organizational_chart_roles":
            case "hand_hygiene_oms_departments_category":
            case "hand_hygiene_oms_operators":
            case "dms_classification_types":
            case "dms_category_types":
            case "dms_files_validation_flow":
            case "dms_keywords":
                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    },
                ];

                break;
            case "business_unit_types":

                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    },
                    {
                        fieldName: "Icon",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('icon', { ns: 'labels' })
                    },
                ];
                break;

            case "risk_area":
                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    },
                    {
                        fieldName: "RISK",
                        fieldType: "number",
                        key: true,
                        hidden: true,
                        name: t('riskLevel', { ns: 'labels' }),
                        defaultValue: 0
                    },
                ];
                break;

            case "functional_chart_roles":
                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    },
                    {
                        fieldName: "DataEntry",
                        fieldType: "bool",
                        key: true,
                        hidden: true,
                        name: t('dataEntry', { ns: 'labels' })
                    },
                    {
                        fieldName: "Verifier",
                        fieldType: "bool",
                        key: true,
                        hidden: true,
                        name: t('verifier', { ns: 'labels' })
                    },
                    {
                        fieldName: "Validator",
                        fieldType: "bool",
                        key: true,
                        hidden: true,
                        name: t('validator', { ns: 'labels' })
                    },
                    {
                        fieldName: "ItemOrder",
                        fieldType: "number",
                        key: true,
                        hidden: true,
                        name: t('order', { ns: 'labels' }),
                        defaultValue: 0
                    },
                ];

                break;

            case "requisites_main_contexts":
                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    },
                    {
                        fieldName: "ItemOrder",
                        fieldType: "number",
                        key: true,
                        hidden: true,
                        name: t('order', { ns: 'labels' }),
                        defaultValue: 0
                    },
                ];
                break;
            case "hospital_regimen_types":
                return [
                    {
                        fieldName: "Code",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('code', { ns: 'labels' })
                    },
                    {
                        fieldName: "Name",
                        fieldType: "string",
                        key: true,
                        hidden: true,
                        name: t('name', { ns: 'labels' })
                    }
                ];
                break;
            default:
                break;
        }
    }

    const _get_table_cell = (params) => {
        const { field, row_data, onChange, row_id } = params;

        const _getCellInput = () => {
            switch (field.fieldType) {
                case "datetime": {
                    return (<input type="datetime-local" className="form-control" onChange={(e) => {
                        if (e.target.valueAsNumber && !isNaN(e.target.valueAsNumber)) {
                            row_data[field.fieldName] = new Date(e.target.valueAsNumber);
                        } else {
                            row_data[field.fieldName] = null;
                        }
                        _onChange();

                    }}
                        onBlur={(e) => {
                            _onBlur();
                        }}
                        onFocus={(e) => {
                            _onFocus();
                        }}
                        ref={(r) => {
                            if (!r) return;
                            if (row_data[field.fieldName] instanceof Date && !isNaN(row_data[field.fieldName])) {
                                r.valueAsNumber = new Date(row_data[field.fieldName]);
                            }
                            else {
                                if (row_data[field.fieldName]) {
                                    try {
                                        r.valueAsNumber = new Date(row_data[field.fieldName]);
                                    }
                                    catch (err) {
                                        r.valueAsNumber = null
                                    }
                                }
                            }
                        }}
                    ></input>)
                }
                    break;
                case "date": {
                    return (<input type="date" className="form-control" onChange={(e) => {
                        row_data[field.fieldName] = e.target.valueAsDate;
                        _onChange();
                    }}
                        onBlur={(e) => {
                            _onBlur();
                        }}
                        onFocus={(e) => {
                            _onFocus();
                        }}
                        ref={(r) => {
                            if (!r) return;
                            if (row_data[field.fieldName] instanceof Date && !isNaN(row_data[field.fieldName])) {
                                r.valueAsDate = row_data[field.fieldName];
                            }
                            else {
                                if (row_data[field.fieldName]) {
                                    try {
                                        r.valueAsDate = new Date(row_data[field.fieldName]);
                                    }
                                    catch (err) {
                                        r.valueAsDate = null
                                    }
                                }
                            }
                        }}
                    ></input>)
                }
                    break;
                case "bool": {
                    return (
                        <div className="form-check  form-switch text-center">
                            <input className="form-check-input" type="checkbox" checked={row_data[field.fieldName] ? true : false}
                                onChange={(e) => {
                                    row_data[field.fieldName] = e.target.checked;
                                    _onChange(true);
                                }}
                                ref={(r) => {
                                    if (!r) return;
                                }}
                            ></input>
                        </div>
                    )
                }
                    break;
                case "number": {
                    return (<input type="number" className="form-control " onChange={(e) => {
                        row_data[field.fieldName] = e.target.valueAsNumber;
                        _onChange();
                    }}
                        onBlur={(e) => {
                            _onBlur();
                        }}
                        onFocus={(e) => {
                            _onFocus();
                        }}
                        ref={(r) => {
                            if (!r) return;
                            r.valueAsNumber = row_data[field.fieldName] ?? field.defaultValue;
                        }}
                    ></input>)
                }
                    break;
                case "string":
                default: {
                    return (<input type="text" className="form-control" value={row_data[field.fieldName]}
                        onChange={(e) => {
                            row_data[field.fieldName] = e.target.value;
                            _onChange();
                        }}
                        onBlur={(e) => {
                            _onBlur();
                        }}
                        onFocus={(e) => {
                            _onFocus();
                        }}
                    ></input>)
                }
            }
        }

        const _td = (
            <td key={`${row_id}_${field.fieldName}`}>
                {_getCellInput()}
            </td>
        );

        const _onChange = (undo) => {
            if (onChange) onChange(row_data, undo);
        }

        const _onFocus = () => {
            row_data[`${field.fieldName}__originalValue`] = null;
            row_data[`${field.fieldName}__originalValue`] = row_data[field.fieldName];
        }

        const _onBlur = () => {
            if (row_data[`${field.fieldName}__originalValue`] != row_data[field.fieldName]) {
                if (onChange) _onChange(true);
            }
        }

        return _td;
    }

    const _get_table_row = (params) => {
        const { voc_schema, row_data, onChange } = params;
        const _cells = [];
        const row_id = `row_${data.data.findIndex(x => x === row_data)}`;

        for (var f of voc_schema) {
            _cells.push(_get_table_cell({
                row_id,
                field: f, row_data, onChange: (r, undo) => {
                    if (onChange) onChange(r);
                    if (undo) undo_redo.push(data.data);
                }
            }));
        }

        _cells.push(
            (<td key={`${row_id}_delete__$command`} className="text-center" onClick={(e) => {
                _deleteRow({ row: row_data });
                undo_redo.push(data.data);
            }}>
                <i className="fa fa-trash fa-2x hover-icon-trash"></i>

            </td>)
        );

        return (
            <tr key={row_id}>
                {_cells.map((c) => c)}
            </tr>
        );
    }

    const _get_table = (params) => {
        const { voc_schema, data } = params;

        const _headers = [];
        for (var f of voc_schema) {
            _headers.push((<th key={`header_${f.name}`}>{f.name}</th>));
        }
        _headers.push((<th key={`header_delete__$command`} className="col-1">{t('delete', { ns: 'labels' })}</th>));

        const _rows = [];
        for (var d of data) {
            _rows.push(_get_table_row({
                voc_schema, row_data: d, onChange: (r) => {
                    setData({
                        voc_schema,
                        data
                    });
                }
            }));
        }

        return (<table className="table ">
            <thead>
                <tr>
                    {_headers.map((h) => h)}
                </tr>
            </thead>
            <tbody>
                {_rows.map((r) => r)}
            </tbody>
        </table>);
    }

    const _getContent = (params) => {
        if (data) {
            return (_get_table({ voc_schema: data.voc_schema, data: data.data }));
        } else {
            return (<h1>{t('loading', { ns: 'labels' })}</h1>);
        }
    }

    return (

        <div className="d-flex flex-column" style={{ height: '100vh' }}>

            {/* HEADER + TOOLBAR (fixed, never scrolls) */}
            <header className="bg-white shadow-sm" style={{ position: 'sticky', top: 0, zIndex: 1000 }}>
                <div className="container-fluid d-flex justify-content-between align-items-center py-2 fixed-toolbar">
                    {/* breadcrumb navigation */}
                    <ol className="breadcrumb mb-0"></ol>

                    {/* action buttons */}
                    <div className="d-flex gap-3">
                        <Undo_Redo onInit={(r) => {
                            undo_redo = r;
                        }}
                            onChange={(d) => {
                                setData({
                                    voc_schema: data.voc_schema,
                                    data: d
                                });
                            }}
                        ></Undo_Redo>
                        <a className="text-primary" onClick={() => {
                            data.data.push({});
                            setData({
                                voc_schema: data.voc_schema,
                                data: data.data
                            });
                            undo_redo.push(data.data);
                        }} role="button" title={t('addNewData', { ns: 'labels' })}>
                            <i className="fa-solid fa-plus fa-2x me-3"></i>
                        </a>
                        <a className="text-primary fs-13" onClick={(e) => {
                            _save();
                        }} role="button" aria-controls="offcanvasExample1" title={t('saveData', { ns: 'labels' })}>
                            <i className="fa-solid fa-floppy-disk fa-2x"></i>
                        </a>
                    </div>
                </div>
            </header>

            {/* SCROLLABLE CONTENT AREA */}
            <main className="flex-grow-1 overflow-auto">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body p-0">
                                    <ul className="nav nav-tabs" id="tabs" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="data-tab" data-bs-toggle="tab" data-bs-target="#data-content" type="button" role="tab" aria-controls="data-content" aria-selected="false">{t('data', { ns: 'labels' })}</button>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                        <div className="tab-pane fade active show" id="data-content" role="tabpanel" aria-labelledby="data-tab">
                                            {_getContent()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </div>

    );
}

export { Vocs_Editor }